import {listingSeo} from '~/utils/site-seo.mjs';
export function useListingSeo(options:any){
 const route=useRoute();
 const seo=computed(()=>listingSeo({path:route.path,query:route.query,...(typeof options==='function'?options():options)}));
 useSeoMeta({title:()=>seo.value.title,description:()=>seo.value.description,ogTitle:()=>seo.value.title,ogDescription:()=>seo.value.description,ogUrl:()=>seo.value.canonical,robots:()=>seo.value.noindex?'noindex, follow':'index, follow'});
 useHead(()=>({link:[{key:'canonical',rel:'canonical',href:seo.value.canonical}]}));
}
